<base-index-page
  [config]="baseIndexPageConfig"
  [service]="introducersService"
  [idKey]="'projectId'"
  [autoLoad]="false"
  (onFiltersChanged)="onFiltersChanged($event)">

  <div class="row">
    <div class="col-md-3 col-sm-6">
      <select-field
        [label]="'Introducers Name'"
        [options]="introducerOptions"
        [selectFormControl]="introducerControl"
        [readonly]="isIntroducerSelectLocked"
        (selectionChange)="onIntroducerChange($event)" />
    </div>
    <div class="col-md-3 col-sm-6">
      <input-field
        [label]="'Starting Date'"
        [inputFormControl]="startingDateControl"
        [readonly]="true" />
    </div>
    <div class="col-md-3 col-sm-6">
      <input-field
        [label]="'Filter from'"
        type="date"
        [inputFormControl]="filterFromControl" />
    </div>
    <div class="col-md-3 col-sm-6">
      <input-field
        [label]="'Filter to'"
        type="date"
        [inputFormControl]="filterToControl" />
    </div>
  </div>

  <h3 class="panel-title mt-4">Totals</h3>
  <div class="totals-panel row g-3 mb-4">
    <div class="col-md-6">
      <div class="totals-tile">
        <span class="totals-value text-primary">
          {{ isLoadingTotals ? '—' : (totals?.totalOrders ?? 0) }}
        </span>
        <span class="totals-labels">
          <span class="totals-title">Total Orders</span>
          <span class="totals-subtitle">This year projects</span>
        </span>
      </div>
    </div>
    <div class="col-md-6">
      <div class="totals-tile">
        <span class="totals-value text-warning">
          {{ isLoadingTotals ? '—' : formatCurrency(totals?.totalRevenue ?? 0) }}
        </span>
        <span class="totals-labels">
          <span class="totals-title">Products Sold</span>
          <span class="totals-subtitle">Total revenue</span>
        </span>
      </div>
    </div>
  </div>

</base-index-page>
